import { computed, watch } from 'vue'
import { useFeatureFlagsStore } from '@/stores/feature-flag'
import { FEATURE_FLAGS } from '@/util/feature-flags.constants'

export interface VersionInfo {
  version: string
  env: string
}

export function startVersionPolling(
  onUpdate: (version: VersionInfo) => void,
  url: string = import.meta.env.VITE_ENV === 'local'
    ? '/version.json'
    : `${import.meta.env.BASE_URL}/version.json`,
  intervalMs: number = 30_000
): { stop: () => void } {
  const featureFlagsStore = useFeatureFlagsStore()

  const alertBannerEnabled = computed(
    () => featureFlagsStore.flags[FEATURE_FLAGS.VERSION_ALERT_BANNER_FLAG]
  )

  let timerId: number | null = null

  const start = () => {
    fetchVersion()
    timerId = window.setInterval(fetchVersion, intervalMs)
  }

  const stopPolling = () => {
    if (timerId !== null) {
      clearInterval(timerId)
      timerId = null
    }
  }

  async function fetchVersion() {
    try {
      const res = await fetch(url, { cache: 'no-store' })
      if (!res.ok) throw new Error(`${res.status} ${res.statusText}`)
      const data = (await res.json()) as VersionInfo
      onUpdate(data)
    } catch (e) {
      console.error('version.json fetch failed:', e)
    }
  }

  const unwatch = watch(
    alertBannerEnabled,
    (enabled) => {
      if (enabled) {
        start()
      } else {
        stopPolling()
      }
    },
    { immediate: true }
  )

  return {
    stop() {
      unwatch()
      stopPolling()
    }
  }
}
